import React from 'react';
import { Badge, ButtonStyle, ButtonVariant, ComponentDataTable, Loader, PageTitle, Table, TableSlotType } from '@develos/next-components';
import { PlatformStatusDetailsType } from '@/types';
import { useSelector } from 'react-redux';
import { storeSelectors } from '@/store';
import { badgeVariant, mapToPlatform } from '@/helpers';
import { useFetch } from '@develos/next-library';

const PlatformStatuses = () => {
  const currentMetricLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
  const currentLocalizationUid = currentMetricLocalization?.uId ?? ''

  const { get } = useFetch();
  const { data: tableConfig, isLoading: isConfigLoading } =
    get<ComponentDataTable<PlatformStatusDetailsType>>('PlatformStatuses/GetLiveDataTableConfiguration');

  const { data: platformStatuses, isFetching: isPlatformStatusLoading, refetch } =
    get<PlatformStatusDetailsType[]>(`PlatformStatuses/GetPlatformStatuses/${currentLocalizationUid}`, {enabled: currentLocalizationUid !== ''});

  const slotedScopes: TableSlotType<PlatformStatusDetailsType> = {
    metricPointPlatformUId: (row: PlatformStatusDetailsType) =>
      mapToPlatform(row.metricPointPlatformUId, currentMetricLocalization),
    status: (row: PlatformStatusDetailsType) => (
      <Badge variant={badgeVariant(row.status < 1)}>
        {row.status >= 1 ? "Aktywny" : "Nieaktywny"}
      </Badge>
    ),
  };

const currentLocalizationPlatformsIds =
  currentMetricLocalization?.metricPointPlatforms.map((x) => x.uId) ?? [];

const filteredData =
  (platformStatuses ?? []).filter((x) =>
    currentLocalizationPlatformsIds.includes(x.metricPointPlatformUId)
  );

  return (
    <div className="rm-relative rm-h-full rm-w-full">
      <PageTitle 
      title="Dashboard | Stan punktów preselekcji" 
      actions=
      {[
        {
          style:ButtonStyle.Basic,
          variant: ButtonVariant.Blue,
          handleClick:refetch,
          children: "Odśwież",
          size:"sm"
        }
      ]}
      />

      {(isPlatformStatusLoading || isConfigLoading) && <Loader isAbsolute />}

      <Table
        data={filteredData}
        headers={tableConfig?.headers ?? []}
        options={tableConfig?.options ?? { headings: {} }}
        slots={slotedScopes}
        showShadow={true}
        noData={{
          title: "Brak danych do wyświetlenia",
        }}
      />
    </div>
  );
};

export default PlatformStatuses;
